const coreWalletInvoiceTypesForSelection = [
	'Simple',
	'Complex'
].map(key => {
	return { id: key, name: key };
});

const coreWalletInvoiceStatusForSelection = [
	'Created',
	'Completed',
	'Cancelled'
].map(key => {
	return { id: key, name: key };
});

export {
	coreWalletInvoiceStatusForSelection,
	coreWalletInvoiceTypesForSelection
};
